import { wantedNotificationService } from "../_services/wantedNotification.service";

function checkWantedGuna(values) {
  return wantedNotificationService.checkWantedGuna(values);
}
function createWantedNotification(values) {
  return wantedNotificationService.createWantedNotification(values);
}
function getWantedNotificationList(values) {
  return wantedNotificationService.getWantedNotificationList(values);
}
function updateWantedNotificationReadBy(values) {
  return wantedNotificationService.updateWantedNotificationReadBy(values);
}

export const wantedNotificationAction = {
  checkWantedGuna,
  createWantedNotification,
  getWantedNotificationList,
  updateWantedNotificationReadBy,
};
